import "./App.css";
import { useState, useEffect } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
// import ChatBot from "./components/ChatBot";
import AvatarLogoCode from "./components/ChartBot/AvatarLogoCode";
import { ChatProductsProvider } from "./context/ChatProductsContext";
import { AppRoutes } from "./routes/route";
import ScrollToTop from "./components/ScrollToTop";
import ConfirmationPopup from "./components/ConfirmationPopup";
import { subscribe as subscribePopup, handlePopupResult, getPopupState } from "./utils/confirmationPopupManager";
import { AlertProvider } from "./components/ChartBot/AlterPopup";
import ToastProvider from "./components/ToastProvider";
import { initLocationTracking } from "./services/location/userLocationService";
import UiAgentSyncTracker from "./components/UiAgentSyncTracker";

export default function App() {
  const [popupState, setPopupState] = useState(getPopupState());

  // Start background location tracking after the app mounts (before login).
  useEffect(() => {
    try {
      initLocationTracking();
    } catch (error) {
      console.warn("[location] Failed to start tracking:", error);
    }
  }, []);

  // Subscribe to popup state changes
  useEffect(() => {
    const unsubscribe = subscribePopup((state) => {
      setPopupState(state);
    });
    return unsubscribe;
  }, []);

  return (
    <ChatProductsProvider>
      <ScrollToTop />
      <UiAgentSyncTracker />
      <Navbar />
      <AppRoutes />
      <AvatarLogoCode />
      <Footer />
      {/* Global Confirmation Popup - renders on main screen */}
      <ConfirmationPopup
        isOpen={popupState.isOpen}
        onResult={handlePopupResult}
        title={popupState.title}
        message={popupState.message}
      />
      {/* Global alert (AlterPopup) */}
      <AlertProvider />
      {/* Site-wide toaster — call showToast() from anywhere */}
      <ToastProvider />
    </ChatProductsProvider>
  );
}
